import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { PhotoManager } from "../components/admin/PhotoManager";
import { EnquiryList } from "../components/admin/EnquiryList";
import { MonthlyReport } from "../components/admin/MonthlyReport";
import { AccountPanel } from "../components/admin/AccountPanel";
import { OrderList } from "../components/admin/OrderList";
import { ReviewList } from "../components/admin/ReviewList";
import { FestivalPanel } from "../components/admin/FestivalPanel";
import { useAuth } from "../context/AuthContext";

export default function Admin() {
  const { user, logout } = useAuth();
  return (
    <main className="min-h-screen bg-[#240620] text-[#FFF8EF]" data-testid="admin-dashboard">
      <header className="border-b border-[#D4AF37]/20 bg-[#190317]">
        <div className="mx-auto flex max-w-[1300px] items-center justify-between gap-4 px-5 py-4 sm:px-8">
          <Link to="/" className="rounded-xl bg-[#FFF8EF] px-2 py-1" data-testid="admin-home-link"><img src="/brand/logo-tight.webp?v=3" alt="SkandaSri Eventz" className="h-10 w-auto" /></Link>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-[#E8D8C8] sm:inline">{user?.email}</span>
            <button onClick={logout} className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-4 py-2 text-sm text-[#F3E5AB]" data-testid="admin-logout-btn"><LogOut size={15} /> Log out</button>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-[1300px] px-5 py-10 sm:px-8">
        <h1 className="font-display text-5xl">Studio dashboard</h1>
        <Tabs defaultValue="photos" className="mt-8">
          <TabsList className="h-auto flex-wrap rounded-3xl bg-[#330B2E] p-1">
            <TabsTrigger value="photos" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-photos">Photos</TabsTrigger>
            <TabsTrigger value="enquiries" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-enquiries">Enquiries</TabsTrigger>
            <TabsTrigger value="orders" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-orders">Order notes</TabsTrigger>
            <TabsTrigger value="reviews" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-reviews">Reviews</TabsTrigger>
            <TabsTrigger value="festival" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-festival">Festival banner</TabsTrigger>
            <TabsTrigger value="account" className="rounded-full px-6 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#240620]" data-testid="admin-tab-account">Account</TabsTrigger>
          </TabsList>
          <TabsContent value="photos" className="mt-8"><PhotoManager /></TabsContent>
          <TabsContent value="enquiries" className="mt-8"><MonthlyReport /><EnquiryList /></TabsContent>
          <TabsContent value="orders" className="mt-8"><OrderList /></TabsContent>
          <TabsContent value="reviews" className="mt-8"><ReviewList /></TabsContent>
          <TabsContent value="festival" className="mt-8"><FestivalPanel /></TabsContent>
          <TabsContent value="account" className="mt-8"><AccountPanel /></TabsContent>
        </Tabs>
      </div>
    </main>
  );
}
